module.exports = __webpack_public_path__ + "img/GS.43e8f6cd.png";